export const checkValidAboutFirm = (jobrole) => {
  const regJobRole = /^[가-힣a-zA-Z0-9\s]{1,20}$/;
  if (regJobRole.test(jobrole)) {
    return true;
  }
};
